import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { IconArrowForward } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "./MegaNav.styles";
import { useTracking } from "../DepartmentsNav/hooks/useTracking/useTracking";
var MegaNavList = function MegaNavList(_ref) {
  var items = _ref.items;
  var tracking = useTracking();
  return /*#__PURE__*/React.createElement(_StyledUl, {
    $_css: styles.list
  }, items.map(function (subItem) {
    return /*#__PURE__*/React.createElement("li", {
      key: subItem.title
    }, /*#__PURE__*/React.createElement(_StyledA, {
      href: subItem.url,
      onClick: function onClick(evt) {
        return tracking.onClickLink(evt, subItem);
      },
      rel: subItem.seo === 'exclude' ? 'nofollow' : undefined,
      $_css2: [styles.listItemText, styles.link]
    }, subItem.title));
  }));
};
var MegaNavListTitle = function MegaNavListTitle(_ref2) {
  var href = _ref2.href,
    rel = _ref2.rel,
    text = _ref2.text,
    titleType = _ref2.titleType;
  var tracking = useTracking();
  var linkTitleTypes = ['regular_link', 'special_link'];
  var isLink = linkTitleTypes.includes(titleType);
  return isLink ? /*#__PURE__*/React.createElement(_StyledA2, {
    href: href,
    onClick: function onClick(evt) {
      return tracking.onClickLink(evt, {
        title: text,
        url: href
      });
    },
    rel: rel,
    title: text,
    $_css3: [styles.title, titleType === 'special_link' ? styles.specialLink : styles.link]
  }, /*#__PURE__*/React.createElement("span", null, text), titleType === 'special_link' && /*#__PURE__*/React.createElement(_StyledIconArrowForward, {
    height: 16,
    width: 16,
    $_css4: styles.forwardArrow
  })) : /*#__PURE__*/React.createElement(_StyledP, {
    $_css5: styles.title
  }, text);
};
export var MegaNav = function MegaNav(_ref3) {
  var columns = _ref3.columns;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-testid": "mega-nav",
    $_css6: styles.container
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css7: styles.inner
  }, columns.map(function (column, columnIndex) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key -- using index as there's nothing in the data we can use instead
      React.createElement(_StyledDiv3, {
        "data-testid": "mega-nav-column",
        key: columnIndex,
        $_css8: styles.column
      }, column.map(function (columnItem, itemIndex) {
        var invisibleLink = columnItem.titleType === 'invisible_link';
        var addTopSpaceToLinkContainer = itemIndex !== 0 && columnItem.titleType !== 'special_link';
        return /*#__PURE__*/React.createElement(_StyledDiv4, {
          // eslint-disable-next-line react/no-array-index-key
          key: itemIndex,
          $_css9: [invisibleLink ? styles.invisibleLinkContainer : undefined, addTopSpaceToLinkContainer ? styles.linkContainerWithTopSpace : undefined]
        }, !invisibleLink && /*#__PURE__*/React.createElement(MegaNavListTitle, {
          href: columnItem.url,
          rel: columnItem.seo === 'exclude' ? 'nofollow' : undefined,
          text: columnItem.title,
          titleType: columnItem.titleType
        }), columnItem.items.length > 0 && /*#__PURE__*/React.createElement(MegaNavList, {
          items: columnItem.items
        }));
      }))
    );
  })));
};
var _StyledUl = _styled("ul")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledA = _styled2("a")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledA2 = _styled3("a")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledIconArrowForward = _styled4(IconArrowForward)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledP = _styled5("p")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledDiv = _styled6("div")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledDiv2 = _styled7("div")(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css7;
});
var _StyledDiv3 = _styled8("div")(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css8;
});
var _StyledDiv4 = /*#__PURE__*/_styled9("div").withConfig({
  displayName: "MegaNav___StyledDiv4",
  componentId: "sc-lmjzgx-0"
})(["", ""], function (p) {
  return p.$_css9;
});